 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		52: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"37fbb85102a50cb35311cfedef19fafb5c5c282a","1":"95b64a6e","2":"4b3250626f31e67b6d8661b86b8ae2063b690b97","3":"93b53e927085db86a28d69c69382e1fb6869776a","4":"28bd1345c4b147cdac76df3d735b091ecab297ac","5":"5e2a4920","6":"f95d4b7ac0c37b5a0a8b62d4430e21afa13d999b","8":"252f366e","11":"component---node-modules-sekmet-gatsby-plugin-offline-app-shell-js","12":"component---src-pages-404-js","13":"component---src-pages-about-us-js","14":"component---src-pages-blog-index-js","15":"component---src-pages-campaign-crypto-services-form-2-js","16":"component---src-pages-campaign-crypto-services-form-3-js","17":"component---src-pages-campaign-crypto-services-form-js","18":"component---src-pages-campaign-crypto-services-js","19":"component---src-pages-campaign-hire-python-fast-conversation-js","20":"component---src-pages-campaign-hire-python-fast-form-js","21":"component---src-pages-careers-js","22":"component---src-pages-case-studies-js","23":"component---src-pages-contact-js","24":"component---src-pages-ebook-it-outsourcing-js","25":"component---src-pages-ebook-it-outsourcing-thank-you-js","26":"component---src-pages-how-we-work-js","27":"component---src-pages-index-js","28":"component---src-pages-industries-blockchain-and-fintech-js","29":"component---src-pages-industries-other-js","30":"component---src-pages-industries-telecommunication-js","31":"component---src-pages-privacy-policy-js","32":"component---src-pages-results-js","33":"component---src-pages-software-services-blockchain-development-js","34":"component---src-pages-software-services-building-products-js","35":"component---src-pages-software-services-code-audit-js","36":"component---src-pages-software-services-cryptocurrency-trading-platforms-js","37":"component---src-pages-software-services-javascript-development-js","38":"component---src-pages-software-services-js","39":"component---src-pages-software-services-mvp-minimum-viable-product-development-js","40":"component---src-pages-software-services-python-development-js","41":"component---src-pages-software-services-team-extension-js","42":"component---src-pages-terms-of-service-js","43":"component---src-pages-thank-you-pages-consultation-js","44":"component---src-pages-thank-you-pages-ebook-it-outsourcing-js","45":"component---src-templates-author-js","46":"component---src-templates-blog-post-js","47":"component---src-templates-blog-topic-js","48":"component---src-templates-case-study-js"}[chunkId]||chunkId) + "-" + {"0":"3c5f59af4ff283798d08","1":"29e2d7d597faaed27e23","2":"fdf081ac204db2381f5b","3":"697eb5b52e24fb588dbd","4":"b1d7578454d455618f61","5":"e4d21bd849936bae601b","6":"a34c9143779552fd563c","8":"f56d54482cc7cccf4461","11":"493a7700b2b6c41a8ae8","12":"c556e048141fe2476067","13":"4639208fd8c1e37b8447","14":"80bb7f622fcd57c4faf2","15":"77ccdcdc0afc84f59ab4","16":"1c21b41e3833c76c10c8","17":"e364879c51040ccffc1c","18":"4511878cbf91ea88163f","19":"39edc6fdc02c4088ee3f","20":"c00864dd3b05d26e1865","21":"c3e568bf2c879ea35fe2","22":"b07fd3ec58d541232162","23":"d8e37cdf200f0706e466","24":"41e0b9f8c58a37bf10a7","25":"fa13f8757ea6e2341c9d","26":"534701d1e830d45aa053","27":"7302eb36e09d6ba16ed7","28":"c181b7fac5f42cdaf5f0","29":"2be8d26b597e25992e75","30":"b8513c271acd62d6a5f5","31":"0fa3e8196cac0f916da0","32":"47cb3a9172bce1921d8f","33":"0abd3bf3a8c394849cfd","34":"e41f8bc6461c8a6be852","35":"0934e03853509fcff1ac","36":"a4633376ea5090ea98b9","37":"dbedf4a5ca4f2c169e6d","38":"8ea3acd08ea8fbcf7c71","39":"8389a8d4ef82457010f2","40":"140d3c04c87054da28b1","41":"2cc091cdf46d7dab7503","42":"024eae62257346c14601","43":"dd65395a39e723a055d6","44":"dabf06e42fcb0ebc5c99","45":"312015169cbc09c21571","46":"a52d64d05a6be8bc878e","47":"4c4330208c7bbc36ace5","48":"878c9f4b27d7cca5ca7a","53":"a7ccfd2ce87bfbaf7c76"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
